import { usageService } from "@/services";
import type { DateRange } from "@/types/api";
import { useQuery } from "@tanstack/react-query";
import { qk } from "./queryKeys";

/**
 * Every fetch is audited server-side as `member.viewed`, so this deliberately
 * does NOT refetch on window focus — an admin leaving a tab open shouldn't
 * manufacture a trail of views they never made.
 */
export function useUsage(range: DateRange = {}) {
	return useQuery({
		queryKey: qk.usage(range),
		queryFn: ({ signal }) => usageService.get(range, signal),
		refetchOnWindowFocus: false,
		staleTime: 60_000,
	});
}
